import { useCallback, useState } from "react";
import { withLockGuard } from "web_myplann/Goals/Helpers/withLockGuard";
import { usePinStepStack } from "web_myplann/Goals/Hooks/usePinStepStack";
import type { PinStep } from "web_myplann/Goals/Types/PinStep";
import { GoalPortfolioTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const useGoalPinStep = (onLockedAction: (() => void) | null) => {
	const { steps, openStep, startAt, closeStep, closeAll } = usePinStepStack();
	const [pinPortfolioType, setPinPortfolioType] =
		useState<GoalPortfolioTypeEnum>(GoalPortfolioTypeEnum.Allocated);

	const openPin = useCallback(
		(type: GoalPortfolioTypeEnum, step: PinStep) => {
			setPinPortfolioType(type);
			startAt(step);
		},
		[startAt],
	);

	return {
		pinSteps: steps,
		pinPortfolioType,
		closePin: closeAll,
		closePinStep: closeStep,
		goToStep: openStep,
		openPin,
		openPinStep: withLockGuard(onLockedAction, (step: PinStep) => {
			if (step === "choose") {
				setPinPortfolioType(GoalPortfolioTypeEnum.Allocated);
			}
			openStep(step);
		}),
		openOwnFundsPin: withLockGuard(onLockedAction, () =>
			openPin(GoalPortfolioTypeEnum.SetAside, "choose"),
		),
	};
};
